import { render } from "./D3CurationGraph.vue?vue&type=template&id=584d2fdc&scoped=true"
import script from "./D3CurationGraph.vue?vue&type=script&lang=js"
export * from "./D3CurationGraph.vue?vue&type=script&lang=js"

import "./D3CurationGraph.vue?vue&type=style&index=0&id=584d2fdc&scoped=true&lang=css"
import "./D3CurationGraph.vue?vue&type=style&index=1&id=584d2fdc&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584d2fdc"]])

export default __exports__